module.exports = __webpack_public_path__ + "static/media/playbooks-thumb.fbd4443b.png";